export function rem(value) {
    return "".concat(value / 16, "rem");
}

//# sourceMappingURL=rem.js.map